import { useSyncExternalStore } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../utils/firebase';
import { collectionPath } from '../utils/firestoreCollections';
import { isAddonEnabled } from '../utils/addons';

// One shared listener on config/addons regardless of how many components use the hook
const EMPTY = { loaded: false, addons: {} };
let state = EMPTY;
let unsubscribe = null;
const listeners = new Set();

function emit(next) {
  state = next;
  listeners.forEach(l => l());
}

function subscribe(listener) {
  listeners.add(listener);
  if (!unsubscribe) {
    unsubscribe = onSnapshot(
      doc(db, collectionPath('config'), 'addons'),
      snap => emit({ loaded: true, addons: snap.exists() ? snap.data() : {} }),
      err => {
        console.error('Failed to load add-ons config:', err.message);
        // Listener is dead after an error; let the next subscriber re-attach
        unsubscribe = null;
        emit({ loaded: true, addons: {} });
      }
    );
  }
  return () => {
    listeners.delete(listener);
    if (listeners.size === 0) {
      if (unsubscribe) unsubscribe();
      unsubscribe = null;
      state = EMPTY;
    }
  };
}

const getSnapshot = () => state;

/** @returns {{ loaded: boolean, addons: Object }} */
export function useAddons() {
  return useSyncExternalStore(subscribe, getSnapshot);
}

/** @returns {{ enabled: boolean, loaded: boolean, config: Object|null }} */
export function useAddon(key) {
  const { loaded, addons } = useAddons();
  return {
    enabled: isAddonEnabled(addons, key),
    loaded,
    config: addons[key] || null
  };
}
